// import React, { useState, useEffect, useRef } from 'react';
// import { toast } from 'react-toastify';
// import { Navigate, useLocation, useNavigate } from 'react-router-dom';
// import { apiService } from '../../constants/ApiService';
// import {
//   Card,
//   Row,
//   Col,
//   CardTitle,
//   CardBody,
//   Button,
//   Form,
//   FormGroup,
//   Label,
//   Input,
//   FormText,
//   Table
// } from "reactstrap";

// import Autocomplete from '@mui/material/Autocomplete';
// import TextField from '@mui/material/TextField';
// import CkEditor from '../../constants/CkEditor';
// import ErrorModal from '../../constants/ErrorModal';
// import { object } from 'prop-types';
// import SpinnerLoader from '../../constants/SpinnerLoader';
// import ItemCategory from './ItemCategory';
// import { useSelector } from 'react-redux';
// import { initialItemCatgyValue, initialItemCatgyValueSuperAdmin } from '../../utils/RegisterMasterKeyword/ItemCategoryKeyword';
// import { useMasterRegistry } from '../../hooks/useMasterRegistry';
// const API_URL = process.env.REACT_APP_API_BASE_URL;

// const AddItemCategory = () => {

//   const navigate = useNavigate();
//   const location = useLocation();

//   const [errorMessage, setErrorMessage] = useState({});
//   const [categoryData, setCategoryData] = useState({
//     category_name: '',
//     category_content: "",
//     category_image: "",
//     online_yn: "no",
//     cate_branch_id: null,
//     cate_vendor_id: null,

//     cate_type: "",
//     cate_id_if_sub_Selected: null,
//     cate_name_if_sub_Selected: "",
//     super_cate_id: null,
//     balance_sheet_id: null,
//     balance_sheet_cate_name: "Stock Group",

//     formula_use: "no",
//     width_yn: "no",
//     thickness_yn: "no",
//     length_yn: "no",
//     fixed_value: null,
//     divided_by: null

//   });
//   const productImageRef = useRef(null)
//   const { user } = useSelector((state) => state.authState);
//   const [editorLoaded, setEditorLoaded] = useState(false);
//   const [previewImage, setPreviewImage] = useState(null);
//   const [balanceSheetList, setBalanceSheetList] = useState([])
//   const [helperMasterSubTable, setHelperMasterSubTable] = useState([]);
//   const [itemCategoryMainTable, setItemCategoryMainTable] = useState([]);
//   const [venderMaster, setVenderMasterTable] = useState([]);
//   const [branchMaster, setBranchMasterTable] = useState([]);
//   const [accessButton, setAccessButton] = useState(false);
//   const [pageloading, setPageLoading] = useState({
//     vender: true,
//     branch: true,
//     // systemDynamic: true,
//   });
//   const [editMode, setEditMode] = useState(false)
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [registerMasterField, setRegisterMasterField] = useState(initialItemCatgyValue);

//   const onHandleBackCategory = () => {
//     navigate(-1)
//   }

//   const onChangeHandle = (e) => {
//     const { name, value, type, files } = e.target;

//     if (type === 'file') {

//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setPreviewImage(reader.result);
//       };
//       reader.readAsDataURL(files[0]);

//       setCategoryData((prevData) => ({
//         ...prevData,
//         [name]: files[0],
//       }));
//     }

//     else {
//       if (name === "cate_type") {

//         if (value == "SUB") {

//           setCategoryData((prevData) => ({
//             ...prevData,
//             [name]: value,
//             cate_name_if_sub_Selected: "",
//             cate_id_if_sub_Selected: null,
//             super_cate_id: categoryData.balance_sheet_id
//           }));
//         } else {

//           setCategoryData((prevData) => ({
//             ...prevData,
//             [name]: value,
//             cate_name_if_sub_Selected: "NOT APPLICABLE",
//             cate_id_if_sub_Selected: 0,
//             super_cate_id: 0
//           }));
//         }
//       }

//       else if (name === "formula_use") {
//         let formulaUse = value;
//         let widthYn = "no";
//         let thicknessYn = "no";
//         let lengthYn = "no";
//         let fixedValue = null;
//         let dividedBy = null;

//         if (value === "yes") {
//           formulaUse = "yes";
//           widthYn = "yes";
//           thicknessYn = "yes";
//           lengthYn = "yes";

//           fixedValue = 0.810;
//           dividedBy = 100000;
//         } else {
//           formulaUse = "no";
//           widthYn = "no";
//           thicknessYn = "no";
//           lengthYn = "no";
//           fixedValue = null;
//           dividedBy = null;
//         }

//         setCategoryData((prevData) => ({
//           ...prevData,
//           [name]: value,               // always update main field
//           formula_use: formulaUse,
//           width_yn: widthYn,
//           thickness_yn: thicknessYn,
//           length_yn: lengthYn,
//           fixed_value: fixedValue,
//           divided_by: dividedBy
//         }));
//       }

//       else {
//         setCategoryData((prevData) => ({
//           ...prevData,
//           [name]: value,
//         }));
//       }
//     }

//     setErrorMessage((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       delete updatedErrors[name];
//       return updatedErrors;
//     });

//   };

//   useEffect(() => {
//     if (categoryData.width_yn == "no" && categoryData.thickness_yn == "no" && categoryData.length_yn == "no") {
//       setCategoryData((prevData) => ({
//         ...prevData,
//         formula_use: "no",
//         fixed_value: null,
//         divided_by: null
//       }));
//     }
//   }, [categoryData.width_yn, categoryData.thickness_yn, categoryData.length_yn])

//   async function uploadImagesFromArrayWithIndex(obj) {

//     if (obj.category_image && typeof obj.category_image === 'object' && obj.category_image !== null && 'name' in obj.category_image) {
//       try {
//         const imageUrl = await uploadImage(obj.category_image);
//         obj.category_image = imageUrl;
//       } catch (error) {
//         console.error(`Error uploading image`, error);
//       }

//     }
//   }

//   async function uploadImage(image) {
//     const uploadData = new FormData();
//     uploadData.append('signature', image);

//     let config = {
//       headers: {
//         'Content-Type': 'multipart/form-data',
//         'accept': 'application/json'
//       }
//     };

//     try {
//       const response = await apiService.post("api/CategoryMaster/uploadfile", uploadData, config);
//       if (response.status === true) {
//         return response.data;
//       } else {
//         throw new Error("Invalid response from server");
//       }
//     } catch (error) {
//       throw new Error("Failed to upload image: " + error.message);
//     }
//   }

//   const validateInputs = () => {
//     const errors = {};

//     if (!categoryData.cate_vendor_id) {
//       errors.cate_vendor_id = 'Vendor is required';
//     }

//     if (!categoryData.cate_branch_id) {
//       errors.cate_branch_id = 'Branch is required';
//     }

//     if (!categoryData.category_name.trim()) {
//       errors.category_name = 'Category name is required.';
//     }

//     if (!categoryData.cate_type.trim()) {
//       errors.cate_type = 'Main/Sub is required.';
//     }

//     // if (categoryData.cate_type == "SUB") {
//     //   errors.cate_name_if_sub_Selected = 'If Sub Then Main Account Name is required.';
//     // }

//     if (categoryData.cate_type == "SUB") {
//       if (!categoryData.cate_name_if_sub_Selected) {
//         errors.cate_name_if_sub_Selected = 'If Sub Then Main Account Name is required.';
//       }
//     }

//     if (!categoryData.online_yn) {
//       errors.online_yn = 'online show is required';
//     }

//     return errors;
//   };

//   const AddCategoryData = async () => {
//     try {

//       // If already submitting, do nothing
//       if (isSubmitting) {
//         return;
//       }

//       setIsSubmitting(true);

//       const errors = validateInputs();
//       if (Object.keys(errors).length > 0) {
//         setErrorMessage(errors);
//         setShowErrorModal(true)
//         setIsSubmitting(false);

//         return;
//       } else {
//         setErrorMessage({})
//       }

//       await uploadImagesFromArrayWithIndex(categoryData)

//       let config = {
//         headers: {
//           'Content-Type': 'application/json', // Important for file upload//s
//           'accept': 'application/json'
//         }
//       };

//       const response = await apiService.post(`api/CategoryMaster/create`, categoryData, config)
//       if (response.response && response.response.data.errors) {
//         toast.success(response.response?.data?.errors);
//       }

//       if (response.status === true) {
//         toast.success(response.message);
//         getCategoryData(response.categoryMasterDetailByID.id)

//         // setCategoryData(response.categoryMasterDetailByID);
//         // setPreviewImage(API_URL + response?.categoryMasterDetailByID?.category_image)
//         // setEditMode(true);
//         // setAccessButton(response.canAccessData)

//         // setPreviewImage(null)
//         // setCategoryData(response.categoryMasterDetailByID)
//       }
//       else {
//         toast.success(response.message);
//       }
//     } catch (error) {
//       console.log(error)
//       toast.error(`SomeThing went wrong!!`);
//     } finally {
//       setIsSubmitting(false); // Re-enable button
//     }
//   };

//   const updateCategoryData = async (id) => {

//     if (isSubmitting) {
//       // If already submitting, do nothing
//       return;
//     }

//     setIsSubmitting(true);

//     const errors = validateInputs();
//     console.log(errors, "erros")
//     if (Object.keys(errors).length > 0) {
//       setErrorMessage(errors);
//       setShowErrorModal(true)
//       setIsSubmitting(false);

//       return;
//     } else {
//       setErrorMessage({})
//     }

//     let params = {
//       category_name: categoryData.category_name,
//       category_content: categoryData.category_content,
//       category_image: categoryData.category_image,
//       online_yn: categoryData.online_yn,

//       cate_type: categoryData.cate_type,
//       cate_name_if_sub_Selected: categoryData.cate_name_if_sub_Selected,
//       cate_id_if_sub_Selected: categoryData.cate_id_if_sub_Selected,
//       balance_sheet_id: categoryData.balance_sheet_id,
//       balance_sheet_cate_name: categoryData.balance_sheet_cate_name,

//       formula_use: categoryData.formula_use,
//       width_yn: categoryData.width_yn,
//       thickness_yn: categoryData.thickness_yn,
//       length_yn: categoryData.length_yn,
//       fixed_value: categoryData.fixed_value,

//       divided_by: categoryData.divided_by,

//       cate_branch_id: categoryData.cate_branch_id,
//       cate_vendor_id: categoryData.cate_vendor_id
//     }

//     await uploadImagesFromArrayWithIndex(params)

//     try {

//       // if (!categoryData.category_name.trim()) {
//       //   setErrorMessage('Category name is required.');
//       //   return;
//       // }

//       let config = {
//         headers: {
//           'Content-Type': 'application/json', // Important for file upload//s
//           'accept': 'application/json'
//         }
//       };

//       const response = await apiService.put(`api/CategoryMaster/update?categoryId=${id}`, params, config)
//       if (response.response && response.response.data.errors) {
//         toast.success(response.response?.data?.errors);
//       }

//       if (response.status === true) {
//         toast.success(response.message)
//         // navigate("/itemCategory")

//       }
//       else {
//         toast.success(response.message);
//       }
//     } catch (error) {
//       console.log(error)
//       toast.error(`SomeThing went wrong!!`);
//     } finally {
//       setIsSubmitting(false); // Re-enable button
//     }
//   }

//   const getCategoryData = async (id) => {
//     try {

//       let config = {
//         headers: {
//           'Content-Type': 'application/json', // Important for file upload//s
//           'accept': 'application/json'
//         }
//       };

//       const response = await apiService.get(`api/CategoryMaster/categorybyid?categoryId=${id}`, config)
//       if (response.response && response.response.data.errors) {
//         toast.success(response.response?.data?.errors);
//       }

//       if (response.status === true) {
//         // toast.success(response.message);
//         setCategoryData(response.categoryMasterDetailByID);
//         setPreviewImage(API_URL + response?.categoryMasterDetailByID?.category_image)
//         getItemCategary(response?.categoryMasterDetailByID?.cate_type)
//         setEditMode(true);
//         setAccessButton(response?.canAccessData)

//         // setPreviewImage(null)
//         // setCategoryData(response.categoryMasterDetailByID)
//       }
//       else {
//         toast.success(response.message);
//       }
//     } catch (error) {
//       console.log(error)
//       toast.error(`SomeThing went wrong!!`);
//     }
//   }

//   useEffect(() => {
//     if (location.state) {
//       getCategoryData(location.state.id)
//       setEditMode(true);
//     }
//   }, [location.state]);

//   const handleSelect = async (event, value) => {

//     if (value === null || value === undefined) {

//       setCategoryData((prevData) => ({
//         ...prevData,
//         balance_sheet_id: null,
//         balance_sheet_cate_name: '',
//       }));

//       return;
//     }
//     let findData = balanceSheetList.find((data) => data.catCode == value.catCode)
//     await setCategoryData((prevData) => ({
//       ...prevData,
//       balance_sheet_id: findData.catCode,
//       balance_sheet_cate_name: findData.cat_name,
//     }));
//   };

//   const getAllBalanceSheet = async () => {
//     try {

//       let config = {
//         headers: {
//           'Content-Type': 'application/json', // Important for file upload//s
//           'accept': 'application/json'
//         }
//       };

//       const response = await apiService.get(`/api/CommonMaster/allBalanceSheetData`, config)
//       if (response.response && response.response.data.errors) {
//         toast.success(response.response?.data?.errors);
//       }

//       if (response.status === true) {
//         // alert(response.message)
//         setBalanceSheetList(response.balanceSheetMasterData)
//       }
//       else {
//         toast.success(response.message);
//       }
//     } catch (error) {
//       console.log(error)
//       toast.error(`SomeThing went wrong!!`);
//     }
//   }

//   // get helepr master data
//   const getHelperMaster = async (formName) => {
//     try {
//       let config = {
//         headers: {
//           'Content-Type': 'application/json', // Important for file upload//s
//           'accept': 'application/json'
//         }
//       };

//       const response = await apiService.get(`/api/HelperMaster/allOption?fromName=${formName}`, config)
//       if (response.response && response.response.data.errors) {
//         toast.success(response.response?.data?.errors);
//       }

//       if (response.status === true) {
//         setHelperMasterSubTable(response.helperMasterData)
//       }
//       else {
//         toast.success(response.message);
//       }
//     } catch (error) {
//       console.log(error)
//       toast.error(`SomeThing went wrong!!`);
//     }
//   }

//   const getItemCategary = async (cate_type) => {
//     try {
//       let config = {
//         headers: {
//           'Content-Type': 'application/json', // Important for file upload//s
//           'accept': 'application/json'
//         }
//       };

//       const response = await apiService.get(`api/CategoryMaster/allcategory?pageNo=1&limit=100000&flagName=${cate_type}`, config)
//       if (response.response && response.response.data.errors) {
//         toast.success(response.response?.data?.errors);
//       }

//       if (response.status === true) {
//         setItemCategoryMainTable(response.categoryMasterDetailData)
//       }
//       else {
//         toast.success(response.message);
//       }
//     } catch (error) {
//       console.log(error)
//       toast.error(`SomeThing went wrong!!`);
//     }
//   }

//   const handleSubSelect = async (event, value) => {

//     if (value === null || value === undefined) {

//       setCategoryData((prevData) => ({
//         ...prevData,
//         cate_id_if_sub_Selected: null,
//         cate_name_if_sub_Selected: '',
//       }));
//       return;
//     }
//     let findData = itemCategoryMainTable.find((data) => data.id == value.id)
//     await setCategoryData((prevData) => ({
//       ...prevData,
//       cate_id_if_sub_Selected: findData.id,
//       cate_name_if_sub_Selected: findData.category_name,
//     }));
//   };

//   const [showErrorModal, setShowErrorModal] = useState(false)

//   const getVendorName = async (page = 1, limit = 10, search = "") => {
//     try {
//       let config = {
//         headers: {
//           'Content-Type': 'application/json', // Important for file upload//s
//           'accept': 'application/json'
//         }
//       };

//       const response = await apiService.get(`/api/VenderMaster/all?pageNo=${page}&limit=${100000}&searchKey=${search}`, config)
//       if (response.response && response.response.data.errors) {
//         toast.success(response.response?.data?.errors);
//       }

//       if (response.status === true) {
//         // console.log(response.CompanyMasterMasterData)
//         if (response.venderMasterData.length == 1 && response.venderMasterData) {

//           setVenderMasterTable(response.venderMasterData)
//           setCategoryData((prevDetails) => ({
//             ...prevDetails,
//             cate_vendor_id: response.venderMasterData[0].id,
//           }));

//         }
//         // else if (response.venderMasterData.length == 0) {
//         //   setVenderMasterTable(response.venderMasterData)
//         //   setCategoryData((prevDetails) => ({
//         //     ...prevDetails,
//         //     cate_vendor_id: null
//         //   }));

//         //   setErrorMessage((prevDetails) => ({
//         //     ...prevDetails,
//         //     cate_vendor_id: 'Vender is required'
//         //   }));

//         //   setShowErrorModal(true)
//         // }
//         else {
//           setVenderMasterTable(response.venderMasterData)
//         }
//         // toast.success(response.message);
//       }
//       else {
//         toast.success(response.message);
//       }
//     } catch (error) {
//       console.log(error)
//       toast.error(`SomeThing went wrong!!`);
//     } finally {
//       setPageLoading(prev => ({ ...prev, vender: false }));
//     }
//   };

//   const getBranchData = async (page = 1, limit = 10, search = "") => {
//     try {
//       let config = {
//         headers: {
//           'Content-Type': 'application/json', // Important for file upload//s
//           'accept': 'application/json'
//         }
//       };

//       // const filterName = categoryData.cate_vendor_id ? categoryData.cate_vendor_id : null;
//       const filterName = user.user_profile == "superadmin" ? categoryData.cate_vendor_id : categoryData.accessButton ? categoryData.cate_vendor_id : null;
//       let queryString = `pageNo=${page}&limit=100000&searchKey=${search}`;
//       if (filterName) {
//         queryString += `&filterName=${filterName}`;
//       }

//       const response = await apiService.get(`/api/BranchMaster/all?${queryString}`, config);
//       if (response.response && response.response.data.errors) {
//         toast.success(response.response?.data?.errors);
//       }

//       if (response.status === true) {
//         // console.log(response.BranchMasterMasterData)
//         // setBranchMasterTable(response.branchMasterData)

//         if (response.branchMasterData.length == 1 && response.branchMasterData) {

//           setBranchMasterTable(response.branchMasterData)
//           setCategoryData((prevDetails) => ({
//             ...prevDetails,
//             cate_branch_id: response?.branchMasterData[0]?.id,
//           }));

//         }
//         else if (response.branchMasterData.length == 0) {
//           setBranchMasterTable(response.branchMasterData)

//           // setCategoryData((prevDetails) => ({
//           //   ...prevDetails,
//           //   cate_branch_id: null
//           // }));

//           setErrorMessage((prevDetails) => ({
//             ...prevDetails,
//             cate_branch_id: 'Branch is required'
//           }));

//           setShowErrorModal(true)

//         }
//         else {
//           setBranchMasterTable(response.branchMasterData)
//           // setCategoryData((prevDetails) => ({
//           //   ...prevDetails,
//           //   cate_branch_id: null
//           // }));
//         }

//         // toast.success(response.message);
//       }
//       else {
//         toast.success(response.message);
//       }
//     } catch (error) {
//       console.log(error)
//       toast.error(`SomeThing went wrong!!`);
//     } finally {
//       setPageLoading(prev => ({ ...prev, branch: false }));
//     }
//   };

//   useEffect(() => {
//     getVendorName()
//     getBranchData()

//   }, [categoryData?.cate_vendor_id])

//   // useEffect(() => {
//   //   if (user.working_bussinesss_mode && user.user_profile != "superadmin") {
//   //     getRegisterMasterRecord(user.working_bussinesss_mode);
//   //   } else {
//   //     setRegisterMasterField(prevState => ({
//   //       ...prevState,
//   //       ...initialItemCatgyValueSuperAdmin
//   //     }));
//   //   }
//   // }, [user.working_bussinesss_mode]);

//   useMasterRegistry({
//     masterName: "item_category",
//     user,
//     setState: setRegisterMasterField,
//     superAdminDefaults: initialItemCatgyValueSuperAdmin
//   });

//   console.log(registerMasterField, 'registerMasterFieldregisterMasterFieldregisterMasterField')

//   useEffect(() => {

//     const allApisLoaded = Object.values(pageloading).every(status => status === false);

//     if (!allApisLoaded) return;

//     const newErrors = {};

//     if (!venderMaster || venderMaster.length === 0) {
//       newErrors.cate_vendor_id = 'Vender is required.';
//     }

//     if (!branchMaster || branchMaster.length === 0) {
//       newErrors.cate_branch_id = 'Branch is required.';
//     }

//     if (Object.keys(newErrors).length > 0) {
//       setErrorMessage(newErrors);
//       setShowErrorModal(true);
//     } else {
//       setErrorMessage({});
//       setShowErrorModal(false);
//     }
//     setEditorLoaded(true);

//   }, [branchMaster, venderMaster, pageloading]);

//   useEffect(() => {
//     if (user.user_profile == "superadmin") {
//       setAccessButton(true);
//     }
//   }, [])

//   // =========================================   CK EDITOR CODE   =========================================

//   useEffect(() => {

//     let ServiceName = categoryData?.cate_type
//     if (ServiceName == "SUB") {
//       getItemCategary("MAIN")
//     }
//   }, [categoryData?.cate_type])

//   useEffect(() => {
//     getAllBalanceSheet()
//     getHelperMaster("party_category")
//   }, []);

//   const goTODeleteModel = (id) => {
//     const currentUrl = `${window.location.origin}`;
//     const url = `${currentUrl}/commonDelete?itemId=${id}&flag=itemCategory`;
//     window.open(url, '_blank');

//     setTimeout(() => {
//       window.close();
//     }, 1000);
//   };

//   if (Object.values(pageloading).some(status => status == true)) {
//     return <SpinnerLoader />
//   }

//   return (
//     <>
//       <Row>
//         <Col>
//           <Card className='bg-white pd-10 card-box mb-30'>

//             <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between toolbar-row sticky-top"
//             >
//               <div className="d-flex align-items-center">
//                 <i className="bi bi-bell mr-2"></i>
//                 Item Category Master
//               </div>

//               {
//                 editMode ?

//                   <>
//                     {(accessButton && editMode) &&
//                       // (categoryData.cate_vendor_id == user.vender_master_id )|| user.user_profile == "superadmin" &&
//                       <>
//                         <Button
//                           color="danger"
//                           className="ml-auto mr-2"
//                           onClick={() => goTODeleteModel(categoryData?.id)}
//                         >
//                           <i className="bi bi-trash mr-2"></i>
//                           Delete
//                         </Button>
//                         <Button type="button" className="mr-2" color="success"
//                           disabled={isSubmitting}
//                           onClick={() => updateCategoryData(categoryData?.id)}>
//                           <i className="bi bi-save mr-2"></i>
//                           Update
//                         </Button>
//                       </>}

//                   </>

//                   :
//                   <Button type="button" className="ml-auto mr-2" color="success"
//                     disabled={isSubmitting}
//                     onClick={() => AddCategoryData()}>
//                     <i className="bi bi-save mr-2"></i>
//                     Save
//                   </Button>
//               }

//               <Button
//                 color="warning"
//                 onClick={onHandleBackCategory}
//                 className=""
//               >
//                 <i className="bi bi-arrow-left mr-2"></i>               Back
//               </Button>

//             </CardTitle>
//             <CardBody>
//               <Form>

//                 <Row style={{ justifyContent: "center" }}>
//                   <Col md="5">
//                     <FormGroup>
//                       <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                         {
//                           previewImage ?
//                             <img src={previewImage} style={{
//                               width: '100px',
//                               height: '100px',
//                               borderRadius: '50%',
//                               marginBottom: '10px',
//                             }} alt="Preview" />
//                             :
//                             <>
//                               <div style={{
//                                 width: '100px',
//                                 height: '100px',
//                                 borderRadius: '50%',
//                                 backgroundColor: 'lightgray',
//                                 backgroundImage: 'url("")',
//                                 backgroundSize: 'cover',
//                                 marginBottom: '10px',
//                               }} className="rounded-circle"></div>
//                             </>

//                         }
//                         <Input className="custom-border d-none"
//                           id="category_image"
//                           name="category_image"
//                           type="file"
//                           innerRef={productImageRef}
//                           onChange={(e) => { onChangeHandle(e) }}
//                         />

//                         <label htmlFor="category_image" style={{
//                           width: '150px',
//                           textAlign: 'center'
//                         }} className="upload-button btn btn-primary">
//                           Upload Image
//                         </label>
//                       </div>
//                     </FormGroup>
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col sm="12">
//                     {(venderMaster.length === 0 || venderMaster.length > 1) && <FormGroup>
//                       <Label for="cate_vendor_id">Vendor Name</Label>
//                       <Input className="custom-select"
//                         type='select'
//                         id="cate_vendor_id"
//                         name="cate_vendor_id"
//                         value={categoryData.cate_vendor_id}
//                         onChange={onChangeHandle}
//                         disabled={!accessButton}
//                       >
//                         <option value="">Select</option>
//                         {venderMaster.map((option) => (
//                           <option key={option.id} value={option.id} data-id={option.id}>
//                             {option.vender_name}
//                           </option>
//                         ))}
//                       </Input>
//                       {errorMessage.cate_vendor_id && (
//                         <FormText color="danger">{errorMessage.cate_vendor_id}</FormText>
//                       )}
//                     </FormGroup>}
//                   </Col>

//                   <Col sm={12}>
//                     {(branchMaster.length === 0 || branchMaster.length > 1) &&
//                       <FormGroup>
//                         <Label for="cate_branch_id">Branch Name</Label>
//                         <Input className="custom-select"
//                           type='select'
//                           id="cate_branch_id"
//                           name="cate_branch_id"
//                           value={categoryData.cate_branch_id}
//                           onChange={onChangeHandle}
//                           disabled={!accessButton}
//                         >
//                           <option value="">Select</option>
//                           {branchMaster.map((option) => (
//                             <option key={option.id} value={option.id} data-id={option.id}>
//                               {option.branch_name}
//                             </option>
//                           ))}
//                         </Input>
//                         {errorMessage.cate_branch_id && (
//                           <FormText color="danger">{errorMessage.cate_branch_id}</FormText>
//                         )}
//                       </FormGroup>}
//                   </Col>
//                 </Row>

//                 <Row>

//                   <Col sm={6}>
//                     <FormGroup>
//                       <Label for="category_name">Category Name</Label>
//                       <Input
//                         id="category_name"
//                         name="category_name"
//                         onChange={(e) => { onChangeHandle(e) }}
//                         value={categoryData?.category_name}
//                         placeholder="Enter a Category"
//                         type="text"
//                       />
//                       {/* {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>} */}
//                       {errorMessage.category_name && (
//                         <FormText color="danger">{errorMessage.category_name}</FormText>
//                       )}
//                     </FormGroup>
//                   </Col>

//                   {/* <Col>
//                     <FormGroup>
//                       <Label for="balance_sheet_cate_name">Under Account( Balance Sheet Account)</Label> */}

//                   {/* <Autocomplete
//                         size="small"
//                         // sx={{ width: 300 }}
//                         autoHighlight
//                         id="balance_sheet_cate_name"
//                         name="balance_sheet_cate_name"
//                         options={balanceSheetList}
//                         getOptionLabel={(option) => option.cat_name || ""}
//                         renderInput={(params) => <TextField {...params} label="Select" />}
//                         renderOption={(props, option, state) => (
//                           <li {...props} key={state.index}>
//                             {option.cat_name}
//                           </li>
//                         )}
//                         renderGroup={(params) => params}
//                         value={balanceSheetList.find(option => option.cat_name === categoryData.balance_sheet_cate_name) || null}
//                         onChange={handleSelect}
//                         readOnly={true}
//                       /> */}

//                   {/* <Input
//                         id="balance_sheet_cate_name"
//                         name="balance_sheet_cate_name"
//                         onChange={(e) => { onChangeHandle(e) }}
//                         value={categoryData?.balance_sheet_cate_name}
//                         type="text"
//                         disabled
//                       />

//                     </FormGroup>
//                   </Col> */}

//                   <Col sm={6}>
//                     <FormGroup>
//                       <Label for="cate_type">Main or Sub </Label>
//                       <Input className="custom-select"
//                         id="cate_type"
//                         name="cate_type"
//                         onChange={(e) => { onChangeHandle(e) }}
//                         value={categoryData?.cate_type}
//                         // placeholder="Enter a Party Category"
//                         type="select"
//                         disabled={!categoryData?.category_name}
//                       >
//                         <option value="">Select</option>
//                         {helperMasterSubTable.map((option) => (
//                           <option key={option.id} value={option.field_data}>
//                             {option.field_data}
//                           </option>
//                         ))}
//                       </Input>
//                       {errorMessage.cate_type && (
//                         <FormText color="danger">{errorMessage.cate_type}</FormText>
//                       )}
//                       {/* {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>} */}

//                     </FormGroup>
//                   </Col>
//                 </Row>

//                 <Row>

//                   <Col sm={6}>
//                     <FormGroup>
//                       <Label for="cate_name_if_sub_Selected">If Sub Then Main Account Name </Label>
//                       {categoryData.cate_type == "MAIN" ? <Input
//                         id="cate_name_if_sub_Selected"
//                         name="cate_name_if_sub_Selected"
//                         // onChange={(e) => { onChangeHandle(e) }}
//                         value={categoryData?.cate_name_if_sub_Selected}
//                         // placeholder="Enter a Party Category"
//                         type="text"
//                         disabled
//                       />

//                         :

//                         <Autocomplete
//                           size="small"
//                           // sx={{ width: 300 }}
//                           autoHighlight
//                           id="cate_name_if_sub_Selected"
//                           name="cate_name_if_sub_Selected"
//                           options={itemCategoryMainTable}
//                           getOptionLabel={(option) => option.category_name || ""}
//                           renderInput={(params) => <TextField {...params} label="Select" />}
//                           renderOption={(props, option, state) => (
//                             <li {...props} key={state.index}>
//                               {option.category_name}
//                             </li>
//                           )}
//                           renderGroup={(params) => params}
//                           value={itemCategoryMainTable.find(option => option.category_name === categoryData.cate_name_if_sub_Selected) || null}
//                           onChange={handleSubSelect}
//                           readOnly={!categoryData?.cate_type}
//                         />}
//                       {/* {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>} */}

//                     </FormGroup>

//                     {errorMessage.cate_name_if_sub_Selected && (
//                       <FormText color="danger">{errorMessage.cate_name_if_sub_Selected}</FormText>
//                     )}
//                   </Col>

//                   {registerMasterField?.online_show == "yes" && <Col sm={6}>
//                     <FormGroup>
//                       <Label for="online_yn">Online Show</Label>
//                       <Input className="custom-select"
//                         id="online_yn"
//                         name="online_yn"
//                         onChange={(e) => { onChangeHandle(e) }}
//                         value={categoryData?.online_yn}
//                         type="select"
//                       >
//                         <option value="">Select</option>
//                         <option value="yes">Yes</option>
//                         <option value="no">No</option>

//                       </Input>
//                       {/* {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>} */}
//                       {errorMessage.online_yn && (
//                         <FormText color="danger">{errorMessage.online_yn}</FormText>
//                       )}
//                     </FormGroup>

//                   </Col>}

//                 </Row>

//                 {registerMasterField?.formula == "yes" &&
//                   <Row>
//                     <Col sm={2}>
//                       <FormGroup>
//                         <Label for="formula_use">Formula Used</Label>
//                         <Input className="custom-select"
//                           id="formula_use"
//                           name="formula_use"
//                           onChange={(e) => { onChangeHandle(e) }}
//                           value={categoryData?.formula_use}
//                           type="select"
//                         >
//                           <option value="">Select</option>
//                           <option value="yes">Yes</option>
//                           <option value="no">No</option>

//                         </Input>
//                       </FormGroup>
//                     </Col>

//                     <Col sm={2}>
//                       <FormGroup>
//                         <Label for="width_yn">Width [Y/N]</Label>
//                         <Input className="custom-select"
//                           id="width_yn"
//                           name="width_yn"
//                           onChange={(e) => { onChangeHandle(e) }}
//                           value={categoryData?.width_yn}
//                           type="select"
//                         >
//                           <option value="">Select</option>
//                           <option value="yes">Yes</option>
//                           <option value="no">No</option>

//                         </Input>
//                       </FormGroup>
//                     </Col>

//                     <Col sm={2}>
//                       <FormGroup>
//                         <Label for="thickness_yn">Thickness [Y/N]</Label>
//                         <Input className="custom-select"
//                           id="thickness_yn"
//                           name="thickness_yn"
//                           onChange={(e) => { onChangeHandle(e) }}
//                           value={categoryData?.thickness_yn}
//                           type="select"
//                         >
//                           <option value="">Select</option>
//                           <option value="yes">Yes</option>
//                           <option value="no">No</option>

//                         </Input>
//                       </FormGroup>
//                     </Col>

//                     <Col sm={2}>
//                       <FormGroup>
//                         <Label for="length_yn">Length [Y/N]</Label>
//                         <Input className="custom-select"
//                           id="length_yn"
//                           name="length_yn"
//                           onChange={(e) => { onChangeHandle(e) }}
//                           value={categoryData?.length_yn}
//                           type="select"
//                         >
//                           <option value="">Select</option>
//                           <option value="yes">Yes</option>
//                           <option value="no">No</option>

//                         </Input>
//                       </FormGroup>
//                     </Col>

//                     <Col sm={2}>
//                       <FormGroup>
//                         <Label for="fixed_value">Formula Value</Label>
//                         <Input className="custom-select"

//                           id="fixed_value"
//                           name="fixed_value"
//                           onChange={(e) => { onChangeHandle(e) }}
//                           value={categoryData?.fixed_value || ""}
//                           placeholder='0'
//                           type="text"
//                         />
//                       </FormGroup>
//                     </Col>

//                     <Col sm={2}>
//                       <FormGroup>
//                         <Label for="di">Divided By</Label>
//                         <Input className="custom-select"

//                           id="divided_by"
//                           name="divided_by"
//                           onChange={(e) => { onChangeHandle(e) }}
//                           value={categoryData?.divided_by || ""}
//                           placeholder='0'
//                           type="text"
//                         />
//                       </FormGroup>
//                     </Col>

//                   </Row>}

//                 {registerMasterField?.category_des == "yes" && <FormGroup>
//                   <Label for="category_content">Category content</Label>
//                   <CkEditor
//                     name="category_content"
//                     onChange={(data) => {
//                       setCategoryData((prevData) => ({
//                         ...prevData,
//                         category_content: data,
//                       }));
//                     }}
//                     editorLoaded={editorLoaded}
//                     value={categoryData?.category_content}
//                   />
//                 </FormGroup>}

//                 {/* <Button type="button" className="mt-2" color="primary"
//                   disabled={isSubmitting}
//                   onClick={() => AddCategoryData()}>Save</Button> */}

//               </Form>
//             </CardBody>

//             {/* Error Model */}

//             <ErrorModal
//               show={showErrorModal}
//               title="Validation / Action Required"
//               content={errorMessage}
//               condition={true}
//               onCancel={() => setShowErrorModal(false)}
//             // onConfirm={true}
//             />
//           </Card>
//         </Col>
//       </Row>
//     </>
//   );
// };

// export default AddItemCategory;

// // <CardTitle
// //         tag="h6"
// //         className="toolbar-row border-bottom mb-0 d-flex align-items-center justify-content-between flex-wrap sticky-top bg-white rounded-top"
// //       >
// //         {/* Title Section */}
// //         <div className="d-flex align-items-center toolbar-title">
// //           <i className="bi bi-bell text-primary me-2"></i>
// //           <span className="fw-semibold text-dark">Item Category Master</span>
// //         </div>

// //         {/* Button Section */}
// //         <div className="toolbar-buttons d-flex flex-wrap justify-content-end gap-2">
// //           {editMode ? (
// //             <>
// //               {accessButton && (
// //                 <>
// //                   <Button
// //                     color="danger"
// //                     className="d-flex align-items-center"
// //                     onClick={() => goTODeleteModel(categoryData?.id)}
// //                   >
// //                     <i className="bi bi-trash me-2"></i>
// //                     Delete
// //                   </Button>
// //                   <Button
// //                     type="button"
// //                     color="success"
// //                     className="d-flex align-items-center"
// //                     disabled={isSubmitting}
// //                     onClick={() => updateCategoryData(categoryData?.id)}
// //                   >
// //                     <i className="bi bi-save me-2"></i>
// //                     Update
// //                   </Button>
// //                 </>
// //               )}
// //             </>
// //           ) : (
// //             <Button
// //               type="button"
// //               color="success"
// //               className="d-flex align-items-center"
// //               disabled={isSubmitting}
// //               onClick={() => AddCategoryData()}
// //             >
// //               <i className="bi bi-save me-2"></i>
// //               Save
// //             </Button>
// //           )}

// //           <Button
// //             color="warning"
// //             className="d-flex align-items-center"
// //             onClick={onHandleBackCategory}
// //           >
// //             <i className="bi bi-arrow-left me-2"></i>
// //             Back
// //           </Button>
// //         </div>
// //       </CardTitle>

// // /* === Toolbar: Below header, fixed appearance === */
// // .toolbar-row {
// //   background: #fff;
// //   padding: 10px 14px;
// //   border-bottom: 1px solid #e5e5e5;
// //   display: flex;
// //   align-items: center;
// //   justify-content: space-between;
// //   flex-wrap: wrap; /* Allows wrapping on smaller screens */
// //   position: sticky;
// //   top: 60px; /* Adjust to match your header height */
// //   z-index: 1030; /* Below navbar but above content */
// // }

// // /* === Title section (left side) === */
// // .toolbar-title {
// //   display: flex;
// //   align-items: center;
// //   gap: 8px;
// //   font-weight: 600;
// //   color: #0d1b2a;
// //   margin-bottom: 6px;
// // }

// // /* === Button container (right side) === */
// // .toolbar-buttons {
// //   display: flex;
// //   gap: 8px;
// //   flex-wrap: wrap;
// //   white-space: nowrap;
// //   justify-content: flex-end;
// // }

// // /* === Button sizing === */
// // .toolbar-buttons button {
// //   font-size: 13px;
// //   padding: 6px 12px;
// //   display: flex;
// //   align-items: center;
// //   border-radius: 6px;
// //   font-weight: 500;
// // }

// // .toolbar-buttons i {
// //   font-size: 14px;
// //   margin-right: 6px;
// // }

// // /* === Optional small label under icon (if used) === */
// // .btn-label {
// //   font-size: 10px !important;
// //   font-weight: bold;
// //   margin-top: -3px;
// //   text-align: center;
// //   display: block;
// // }

// // /* === Compact Buttons (if custom size needed) === */
// // .btn-size-custom {
// //   font-size: 12px !important;
// //   padding: 4px 8px !important;
// // }

// // /* === Mobile View (≤480px) === */
// // @media (max-width: 480px) {
// //   .toolbar-row {
// //     flex-direction: column;
// //     align-items: flex-start;
// //     gap: 10px;
// //     padding: 8px 10px;
// //   }

// //   .toolbar-buttons {
// //     width: 100%;
// //     justify-content: flex-end;
// //     gap: 6px;
// //   }

// //   .toolbar-buttons button {
// //     flex: 1 1 auto; /* Allow buttons to stretch equally */
// //     font-size: 11px !important;
// //     padding: 6px 8px !important;
// //   }

// //   .toolbar-title {
// //     font-size: 14px;
// //     margin-bottom: 0;
// //   }
// // }
import React, { useState, useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
} from 'reactstrap';

import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CkEditor from '../../constants/CkEditor';
import ErrorModal from '../../constants/ErrorModal';
import SpinnerLoader from '../../constants/SpinnerLoader';
import { useSelector } from 'react-redux';
import {
  initialItemCatgyValue,
  initialItemCatgyValueSuperAdmin,
} from '../../utils/RegisterMasterKeyword/ItemCategoryKeyword';
import { useMasterRegistry } from '../../hooks/useMasterRegistry';

const API_URL = process.env.REACT_APP_API_BASE_URL;

const AddItemCategory = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const productImageRef = useRef(null);
  const { user } = useSelector((state) => state.authState);

  const [errorMessage, setErrorMessage] = useState({});
  const [categoryData, setCategoryData] = useState({
    category_name: '',
    category_content: '',
    category_image: '',
    online_yn: 'no',
    cate_branch_id: null,
    cate_vendor_id: null,

    cate_type: '',
    cate_id_if_sub_Selected: null,
    cate_name_if_sub_Selected: '',
    super_cate_id: null,
    balance_sheet_id: null,
    balance_sheet_cate_name: 'Stock Group',

    formula_use: 'no',
    width_yn: 'no',
    thickness_yn: 'no',
    length_yn: 'no',
    fixed_value: null,
    divided_by: null,
  });

  const [editorLoaded, setEditorLoaded] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [balanceSheetList, setBalanceSheetList] = useState([]);
  const [helperMasterSubTable, setHelperMasterSubTable] = useState([]);
  const [itemCategoryMainTable, setItemCategoryMainTable] = useState([]);
  const [venderMaster, setVenderMasterTable] = useState([]);
  const [branchMaster, setBranchMasterTable] = useState([]);
  const [accessButton, setAccessButton] = useState(false);
  const [pageloading, setPageLoading] = useState({
    vender: true,
    branch: true,
  });
  const [editMode, setEditMode] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [registerMasterField, setRegisterMasterField] = useState(
    initialItemCatgyValue,
  );
  const [showErrorModal, setShowErrorModal] = useState(false);

  const numericFields = [
    'cate_branch_id',
    'cate_vendor_id',
    'cate_id_if_sub_Selected',
    'super_cate_id',
    'balance_sheet_id',
    'fixed_value',
    'divided_by',
  ];

  const parseNullableNumber = (value) => {
    if (value === '' || value === null || value === undefined) return null;
    const parsed = Number(value);
    return Number.isNaN(parsed) ? null : parsed;
  };

  const onHandleBackCategory = () => {
    navigate(-1);
  };

  const onChangeHandle = (e) => {
    const { name, value, type, files } = e.target;

    if (type === 'file') {
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewImage(reader.result);
        };
        reader.readAsDataURL(files[0]);

        setCategoryData((prevData) => ({
          ...prevData,
          [name]: files[0],
        }));
      }
      return;
    }

    let finalValue = value;

    if (numericFields.includes(name)) {
      finalValue = parseNullableNumber(value);
    }

    if (name === 'cate_type') {
      if (value === 'SUB') {
        setCategoryData((prevData) => ({
          ...prevData,
          cate_type: value,
          cate_name_if_sub_Selected: '',
          cate_id_if_sub_Selected: null,
          super_cate_id: prevData.balance_sheet_id,
        }));
      } else {
        setCategoryData((prevData) => ({
          ...prevData,
          cate_type: value,
          cate_name_if_sub_Selected: 'NOT APPLICABLE',
          cate_id_if_sub_Selected: 0,
          super_cate_id: 0,
        }));
      }
    } else if (name === 'formula_use') {
      let formulaUse = value;
      let widthYn = 'no';
      let thicknessYn = 'no';
      let lengthYn = 'no';
      let fixedValue = null;
      let dividedBy = null;

      if (value === 'yes') {
        formulaUse = 'yes';
        widthYn = 'yes';
        thicknessYn = 'yes';
        lengthYn = 'yes';
        fixedValue = 0.81;
        dividedBy = 100000;
      }

      setCategoryData((prevData) => ({
        ...prevData,
        formula_use: formulaUse,
        width_yn: widthYn,
        thickness_yn: thicknessYn,
        length_yn: lengthYn,
        fixed_value: fixedValue,
        divided_by: dividedBy,
      }));
    } else {
      setCategoryData((prevData) => ({
        ...prevData,
        [name]: finalValue,
      }));
    }

    setErrorMessage((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[name];
      return updatedErrors;
    });
  };

  useEffect(() => {
    if (
      categoryData.width_yn === 'no' &&
      categoryData.thickness_yn === 'no' &&
      categoryData.length_yn === 'no'
    ) {
      setCategoryData((prevData) => ({
        ...prevData,
        formula_use: 'no',
        fixed_value: null,
        divided_by: null,
      }));
    }
  }, [
    categoryData.width_yn,
    categoryData.thickness_yn,
    categoryData.length_yn,
  ]);

  async function uploadImagesFromArrayWithIndex(obj) {
    if (
      obj.category_image &&
      typeof obj.category_image === 'object' &&
      obj.category_image !== null &&
      'name' in obj.category_image
    ) {
      try {
        const imageUrl = await uploadImage(obj.category_image);
        obj.category_image = imageUrl;
      } catch (error) {
        console.error(`Error uploading image`, error);
      }
    }
  }

  async function uploadImage(image) {
    const uploadData = new FormData();
    uploadData.append('signature', image);

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        accept: 'application/json',
      },
    };

    try {
      const response = await apiService.post(
        'api/CategoryMaster/uploadfile',
        uploadData,
        config,
      );
      if (response.status === true) {
        return response.data;
      }
      throw new Error('Invalid response from server');
    } catch (error) {
      throw new Error('Failed to upload image: ' + error.message);
    }
  }

  const validateInputs = () => {
    const errors = {};

    if (!categoryData.cate_vendor_id) {
      errors.cate_vendor_id = 'Vendor is required';
    }

    if (!categoryData.cate_branch_id) {
      errors.cate_branch_id = 'Branch is required';
    }

    if (!categoryData.category_name?.trim()) {
      errors.category_name = 'Category name is required.';
    }

    if (!categoryData.cate_type?.trim()) {
      errors.cate_type = 'Main/Sub is required.';
    }

    if (
      categoryData.cate_type === 'SUB' &&
      !categoryData.cate_name_if_sub_Selected
    ) {
      errors.cate_name_if_sub_Selected =
        'If Sub Then Main Account Name is required.';
    }

    if (!categoryData.online_yn) {
      errors.online_yn = 'Online show is required';
    }

    return errors;
  };

  const AddCategoryData = async () => {
    try {
      if (isSubmitting) return;

      setIsSubmitting(true);

      const errors = validateInputs();
      if (Object.keys(errors).length > 0) {
        setErrorMessage(errors);
        setShowErrorModal(true);
        setIsSubmitting(false);
        return;
      } else {
        setErrorMessage({});
      }

      const payload = {
        ...categoryData,
        cate_branch_id: parseNullableNumber(categoryData.cate_branch_id),
        cate_vendor_id: parseNullableNumber(categoryData.cate_vendor_id),
        cate_id_if_sub_Selected: parseNullableNumber(
          categoryData.cate_id_if_sub_Selected,
        ),
        super_cate_id: parseNullableNumber(categoryData.super_cate_id),
        balance_sheet_id: parseNullableNumber(categoryData.balance_sheet_id),
        fixed_value: parseNullableNumber(categoryData.fixed_value),
        divided_by: parseNullableNumber(categoryData.divided_by),
      };

      await uploadImagesFromArrayWithIndex(payload);

      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      console.log('Create Payload:', payload);

      const response = await apiService.post(
        `api/CategoryMaster/create`,
        payload,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        toast.success(response.message);
        getCategoryData(response.categoryMasterDetailByID.id);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const updateCategoryData = async (id) => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    const errors = validateInputs();
    if (Object.keys(errors).length > 0) {
      setErrorMessage(errors);
      setShowErrorModal(true);
      setIsSubmitting(false);
      return;
    } else {
      setErrorMessage({});
    }

    const params = {
      category_name: categoryData.category_name,
      category_content: categoryData.category_content,
      category_image: categoryData.category_image,
      online_yn: categoryData.online_yn,

      cate_type: categoryData.cate_type,
      cate_name_if_sub_Selected: categoryData.cate_name_if_sub_Selected,
      cate_id_if_sub_Selected: parseNullableNumber(
        categoryData.cate_id_if_sub_Selected,
      ),
      balance_sheet_id: parseNullableNumber(categoryData.balance_sheet_id),
      balance_sheet_cate_name: categoryData.balance_sheet_cate_name,

      formula_use: categoryData.formula_use,
      width_yn: categoryData.width_yn,
      thickness_yn: categoryData.thickness_yn,
      length_yn: categoryData.length_yn,
      fixed_value: parseNullableNumber(categoryData.fixed_value),
      divided_by: parseNullableNumber(categoryData.divided_by),

      cate_branch_id: parseNullableNumber(categoryData.cate_branch_id),
      cate_vendor_id: parseNullableNumber(categoryData.cate_vendor_id),
      super_cate_id: parseNullableNumber(categoryData.super_cate_id),
    };

    await uploadImagesFromArrayWithIndex(params);

    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      console.log('Update Payload:', params);

      const response = await apiService.put(
        `api/CategoryMaster/update?categoryId=${id}`,
        params,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        toast.success(response.message);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const getCategoryData = async (id) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/CategoryMaster/categorybyid?categoryId=${id}`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setCategoryData(response.categoryMasterDetailByID);
        setPreviewImage(
          API_URL + response?.categoryMasterDetailByID?.category_image,
        );
        getItemCategary(response?.categoryMasterDetailByID?.cate_type);
        setEditMode(true);
        setAccessButton(response?.canAccessData);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  useEffect(() => {
    if (location.state) {
      getCategoryData(location.state.id);
      setEditMode(true);
    }
  }, [location.state]);

  const handleSelect = async (event, value) => {
    if (value === null || value === undefined) {
      setCategoryData((prevData) => ({
        ...prevData,
        balance_sheet_id: null,
        balance_sheet_cate_name: '',
      }));
      return;
    }

    const findData = balanceSheetList.find(
      (data) => data.catCode == value.catCode,
    );

    setCategoryData((prevData) => ({
      ...prevData,
      balance_sheet_id: parseNullableNumber(findData?.catCode),
      balance_sheet_cate_name: findData?.cat_name || '',
    }));
  };

  const getAllBalanceSheet = async () => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/CommonMaster/allBalanceSheetData`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setBalanceSheetList(response.balanceSheetMasterData);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  const getHelperMaster = async (formName) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/HelperMaster/allOption?fromName=${formName}`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setHelperMasterSubTable(response.helperMasterData);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  const getItemCategary = async (cate_type) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/CategoryMaster/allcategory?pageNo=1&limit=100000&flagName=${cate_type}`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setItemCategoryMainTable(response.categoryMasterDetailData);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  const handleSubSelect = async (event, value) => {
    if (value === null || value === undefined) {
      setCategoryData((prevData) => ({
        ...prevData,
        cate_id_if_sub_Selected: null,
        cate_name_if_sub_Selected: '',
      }));
      return;
    }

    const findData = itemCategoryMainTable.find((data) => data.id == value.id);

    setCategoryData((prevData) => ({
      ...prevData,
      cate_id_if_sub_Selected: parseNullableNumber(findData?.id),
      cate_name_if_sub_Selected: findData?.category_name || '',
    }));
  };

  const getVendorName = async (page = 1, limit = 10, search = '') => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/VenderMaster/all?pageNo=${page}&limit=${100000}&searchKey=${search}`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        if (
          response.venderMasterData.length === 1 &&
          response.venderMasterData
        ) {
          setVenderMasterTable(response.venderMasterData);
          setCategoryData((prevDetails) => ({
            ...prevDetails,
            cate_vendor_id: parseNullableNumber(
              response.venderMasterData[0].id,
            ),
          }));
        } else {
          setVenderMasterTable(response.venderMasterData);
        }
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setPageLoading((prev) => ({ ...prev, vender: false }));
    }
  };

  const getBranchData = async (page = 1, limit = 10, search = '') => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const filterName =
        user.user_profile === 'superadmin'
          ? categoryData.cate_vendor_id
          : categoryData.accessButton
            ? categoryData.cate_vendor_id
            : null;

      let queryString = `pageNo=${page}&limit=100000&searchKey=${search}`;
      if (filterName) {
        queryString += `&filterName=${filterName}`;
      }

      const response = await apiService.get(
        `api/BranchMaster/all?${queryString}`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        if (
          response.branchMasterData.length === 1 &&
          response.branchMasterData
        ) {
          setBranchMasterTable(response.branchMasterData);
          setCategoryData((prevDetails) => ({
            ...prevDetails,
            cate_branch_id: parseNullableNumber(
              response?.branchMasterData[0]?.id,
            ),
          }));
        } else if (response.branchMasterData.length === 0) {
          setBranchMasterTable(response.branchMasterData);
          setErrorMessage((prevDetails) => ({
            ...prevDetails,
            cate_branch_id: 'Branch is required',
          }));
          setShowErrorModal(true);
        } else {
          setBranchMasterTable(response.branchMasterData);
        }
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setPageLoading((prev) => ({ ...prev, branch: false }));
    }
  };

  useEffect(() => {
    getVendorName();
    getBranchData();
  }, [categoryData?.cate_vendor_id]);

  useMasterRegistry({
    masterName: 'item_category',
    user,
    setState: setRegisterMasterField,
    superAdminDefaults: initialItemCatgyValueSuperAdmin,
  });

  useEffect(() => {
    const allApisLoaded = Object.values(pageloading).every(
      (status) => status === false,
    );
    if (!allApisLoaded) return;

    const newErrors = {};

    if (!venderMaster || venderMaster.length === 0) {
      newErrors.cate_vendor_id = 'Vender is required.';
    }

    if (!branchMaster || branchMaster.length === 0) {
      newErrors.cate_branch_id = 'Branch is required.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrorMessage(newErrors);
      setShowErrorModal(true);
    } else {
      setErrorMessage({});
      setShowErrorModal(false);
    }

    setEditorLoaded(true);
  }, [branchMaster, venderMaster, pageloading]);

  useEffect(() => {
    if (user.user_profile === 'superadmin') {
      setAccessButton(true);
    }
  }, [user.user_profile]);

  useEffect(() => {
    if (categoryData?.cate_type === 'SUB') {
      getItemCategary('MAIN');
    }
  }, [categoryData?.cate_type]);

  useEffect(() => {
    getAllBalanceSheet();
    getHelperMaster('party_category');
  }, []);

  const goTODeleteModel = (id) => {
    const currentUrl = `${window.location.origin}`;
    const url = `${currentUrl}/commonDelete?itemId=${id}&flag=itemCategory`;
    window.open(url, '_blank');

    setTimeout(() => {
      window.close();
    }, 1000);
  };

  if (Object.values(pageloading).some((status) => status === true)) {
    return <SpinnerLoader />;
  }

  return (
    <>
      <Row>
        <Col>
          <Card className='bg-white pd-10 card-box mb-30'>
            <CardTitle
              tag='h6'
              className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between toolbar-row sticky-top'
            >
              <div className='d-flex align-items-center'>
                <i className='bi bi-bell mr-2'></i>
                Item Category Master
              </div>

              {editMode ? (
                <>
                  {accessButton && editMode && (
                    <>
                      <Button
                        color='danger'
                        className='ml-auto mr-2'
                        onClick={() => goTODeleteModel(categoryData?.id)}
                      >
                        <i className='bi bi-trash mr-2'></i>
                        Delete
                      </Button>
                      <Button
                        type='button'
                        className='mr-2'
                        color='success'
                        disabled={isSubmitting}
                        onClick={() => updateCategoryData(categoryData?.id)}
                      >
                        <i className='bi bi-save mr-2'></i>
                        Update
                      </Button>
                    </>
                  )}
                </>
              ) : (
                <Button
                  type='button'
                  className='ml-auto mr-2'
                  color='success'
                  disabled={isSubmitting}
                  onClick={AddCategoryData}
                >
                  <i className='bi bi-save mr-2'></i>
                  Save
                </Button>
              )}

              <Button color='warning' onClick={onHandleBackCategory}>
                <i className='bi bi-arrow-left mr-2'></i>
                Back
              </Button>
            </CardTitle>

            <CardBody>
              <Form>
                <Row style={{ justifyContent: 'center' }}>
                  <Col md='5'>
                    <FormGroup>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                        }}
                      >
                        {previewImage ? (
                          <img
                            src={previewImage}
                            style={{
                              width: '100px',
                              height: '100px',
                              borderRadius: '50%',
                              marginBottom: '10px',
                            }}
                            alt='Preview'
                          />
                        ) : (
                          <div
                            style={{
                              width: '100px',
                              height: '100px',
                              borderRadius: '50%',
                              backgroundColor: 'lightgray',
                              backgroundImage: 'url("")',
                              backgroundSize: 'cover',
                              marginBottom: '10px',
                            }}
                            className='rounded-circle'
                          ></div>
                        )}

                        <Input
                          className='custom-border d-none'
                          id='category_image'
                          name='category_image'
                          type='file'
                          innerRef={productImageRef}
                          onChange={onChangeHandle}
                        />

                        <label
                          htmlFor='category_image'
                          style={{ width: '150px', textAlign: 'center' }}
                          className='upload-button btn btn-primary'
                        >
                          Upload Image
                        </label>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col sm='12'>
                    {(venderMaster.length === 0 || venderMaster.length > 1) && (
                      <FormGroup>
                        <Label for='cate_vendor_id'>Vendor Name</Label>
                        <Input
                          className='custom-select'
                          type='select'
                          id='cate_vendor_id'
                          name='cate_vendor_id'
                          value={categoryData.cate_vendor_id ?? ''}
                          onChange={onChangeHandle}
                          disabled={!accessButton}
                        >
                          <option value=''>Select</option>
                          {venderMaster.map((option) => (
                            <option
                              key={option.id}
                              value={option.id}
                              data-id={option.id}
                            >
                              {option.vender_name}
                            </option>
                          ))}
                        </Input>
                        {errorMessage.cate_vendor_id && (
                          <FormText color='danger'>
                            {errorMessage.cate_vendor_id}
                          </FormText>
                        )}
                      </FormGroup>
                    )}
                  </Col>

                  <Col sm={12}>
                    {(branchMaster.length === 0 || branchMaster.length > 1) && (
                      <FormGroup>
                        <Label for='cate_branch_id'>Branch Name</Label>
                        <Input
                          className='custom-select'
                          type='select'
                          id='cate_branch_id'
                          name='cate_branch_id'
                          value={categoryData.cate_branch_id ?? ''}
                          onChange={onChangeHandle}
                          disabled={!accessButton}
                        >
                          <option value=''>Select</option>
                          {branchMaster.map((option) => (
                            <option
                              key={option.id}
                              value={option.id}
                              data-id={option.id}
                            >
                              {option.branch_name}
                            </option>
                          ))}
                        </Input>
                        {errorMessage.cate_branch_id && (
                          <FormText color='danger'>
                            {errorMessage.cate_branch_id}
                          </FormText>
                        )}
                      </FormGroup>
                    )}
                  </Col>
                </Row>

                <Row>
                  <Col sm={6}>
                    <FormGroup>
                      <Label for='category_name'>Category Name</Label>
                      <Input
                        id='category_name'
                        name='category_name'
                        onChange={onChangeHandle}
                        value={categoryData?.category_name}
                        placeholder='Enter a Category'
                        type='text'
                      />
                      {errorMessage.category_name && (
                        <FormText color='danger'>
                          {errorMessage.category_name}
                        </FormText>
                      )}
                    </FormGroup>
                  </Col>

                  <Col sm={6}>
                    <FormGroup>
                      <Label for='cate_type'>Main or Sub</Label>
                      <Input
                        className='custom-select'
                        id='cate_type'
                        name='cate_type'
                        onChange={onChangeHandle}
                        value={categoryData?.cate_type}
                        type='select'
                        disabled={!categoryData?.category_name}
                      >
                        <option value=''>Select</option>
                        {helperMasterSubTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_data}
                          </option>
                        ))}
                      </Input>
                      {errorMessage.cate_type && (
                        <FormText color='danger'>
                          {errorMessage.cate_type}
                        </FormText>
                      )}
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col sm={6}>
                    <FormGroup>
                      <Label for='cate_name_if_sub_Selected'>
                        If Sub Then Main Account Name
                      </Label>
                      {categoryData.cate_type === 'MAIN' ? (
                        <Input
                          id='cate_name_if_sub_Selected'
                          name='cate_name_if_sub_Selected'
                          value={categoryData?.cate_name_if_sub_Selected}
                          type='text'
                          disabled
                        />
                      ) : (
                        <Autocomplete
                          size='small'
                          autoHighlight
                          id='cate_name_if_sub_Selected'
                          name='cate_name_if_sub_Selected'
                          options={itemCategoryMainTable}
                          getOptionLabel={(option) =>
                            option.category_name || ''
                          }
                          renderInput={(params) => (
                            <TextField {...params} label='Select' />
                          )}
                          renderOption={(props, option, state) => (
                            <li {...props} key={state.index}>
                              {option.category_name}
                            </li>
                          )}
                          renderGroup={(params) => params}
                          value={
                            itemCategoryMainTable.find(
                              (option) =>
                                option.category_name ===
                                categoryData.cate_name_if_sub_Selected,
                            ) || null
                          }
                          onChange={handleSubSelect}
                          readOnly={!categoryData?.cate_type}
                        />
                      )}
                    </FormGroup>

                    {errorMessage.cate_name_if_sub_Selected && (
                      <FormText color='danger'>
                        {errorMessage.cate_name_if_sub_Selected}
                      </FormText>
                    )}
                  </Col>

                  {registerMasterField?.online_show === 'yes' && (
                    <Col sm={6}>
                      <FormGroup>
                        <Label for='online_yn'>Online Show</Label>
                        <Input
                          className='custom-select'
                          id='online_yn'
                          name='online_yn'
                          onChange={onChangeHandle}
                          value={categoryData?.online_yn}
                          type='select'
                        >
                          <option value=''>Select</option>
                          <option value='yes'>Yes</option>
                          <option value='no'>No</option>
                        </Input>
                        {errorMessage.online_yn && (
                          <FormText color='danger'>
                            {errorMessage.online_yn}
                          </FormText>
                        )}
                      </FormGroup>
                    </Col>
                  )}
                </Row>

                {registerMasterField?.formula === 'yes' && (
                  <Row>
                    <Col sm={2}>
                      <FormGroup>
                        <Label for='formula_use'>Formula Used</Label>
                        <Input
                          className='custom-select'
                          id='formula_use'
                          name='formula_use'
                          onChange={onChangeHandle}
                          value={categoryData?.formula_use}
                          type='select'
                        >
                          <option value=''>Select</option>
                          <option value='yes'>Yes</option>
                          <option value='no'>No</option>
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col sm={2}>
                      <FormGroup>
                        <Label for='width_yn'>Width [Y/N]</Label>
                        <Input
                          className='custom-select'
                          id='width_yn'
                          name='width_yn'
                          onChange={onChangeHandle}
                          value={categoryData?.width_yn}
                          type='select'
                        >
                          <option value=''>Select</option>
                          <option value='yes'>Yes</option>
                          <option value='no'>No</option>
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col sm={2}>
                      <FormGroup>
                        <Label for='thickness_yn'>Thickness [Y/N]</Label>
                        <Input
                          className='custom-select'
                          id='thickness_yn'
                          name='thickness_yn'
                          onChange={onChangeHandle}
                          value={categoryData?.thickness_yn}
                          type='select'
                        >
                          <option value=''>Select</option>
                          <option value='yes'>Yes</option>
                          <option value='no'>No</option>
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col sm={2}>
                      <FormGroup>
                        <Label for='length_yn'>Length [Y/N]</Label>
                        <Input
                          className='custom-select'
                          id='length_yn'
                          name='length_yn'
                          onChange={onChangeHandle}
                          value={categoryData?.length_yn}
                          type='select'
                        >
                          <option value=''>Select</option>
                          <option value='yes'>Yes</option>
                          <option value='no'>No</option>
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col sm={2}>
                      <FormGroup>
                        <Label for='fixed_value'>Formula Value</Label>
                        <Input
                          className='custom-select'
                          id='fixed_value'
                          name='fixed_value'
                          onChange={onChangeHandle}
                          value={categoryData?.fixed_value ?? ''}
                          placeholder='0'
                          type='text'
                        />
                      </FormGroup>
                    </Col>

                    <Col sm={2}>
                      <FormGroup>
                        <Label for='divided_by'>Divided By</Label>
                        <Input
                          className='custom-select'
                          id='divided_by'
                          name='divided_by'
                          onChange={onChangeHandle}
                          value={categoryData?.divided_by ?? ''}
                          placeholder='0'
                          type='text'
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                )}

                {registerMasterField?.category_des === 'yes' && (
                  <FormGroup>
                    <Label for='category_content'>Category content</Label>
                    <CkEditor
                      name='category_content'
                      onChange={(data) => {
                        setCategoryData((prevData) => ({
                          ...prevData,
                          category_content: data,
                        }));
                      }}
                      editorLoaded={editorLoaded}
                      value={categoryData?.category_content}
                    />
                  </FormGroup>
                )}
              </Form>
            </CardBody>

            <ErrorModal
              show={showErrorModal}
              title='Validation / Action Required'
              content={errorMessage}
              condition={true}
              onCancel={() => setShowErrorModal(false)}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default AddItemCategory;
